import { Logo } from "@assets";

export const Header = () => {
  return (
    <header className="h-[40px] flex items-center justify-center border-b border-[#D8DCDE] pb-2.5">
      <img src={Logo} alt="Logo" className="h-[24px]" />
    </header>
  );
};
